import type { ConceptDef } from '../types';

export const yesNoIsIt: ConceptDef = {
  kind: 'yesNo',
  id: 'yesno-is-it',
  label: 'Yes or No: Is It a…?',
  category: 'Receptive',
  description: 'See a picture and answer “Is this a …?” with Yes or No.',
  config: {
    promptMode: 'AUDIO',
    errorless: 'off',
    items: [
      { say: '🐶 Is this a dog?', answer: 'yes' },
      { say: '🐱 Is this a dog?', answer: 'no' },
      { say: '🍎 Is this an apple?', answer: 'yes' },
      { say: '🚗 Is this a bus?', answer: 'no' },
      { say: '✋ Is this a hand?', answer: 'yes' },
      { say: '🌞 Is this the moon?', answer: 'no' },
      { say: '🍌 Is this a banana?', answer: 'yes' },
      { say: '🐟 Is this a bird?', answer: 'no' },
    ],
  },
};

export const yesNoColours: ConceptDef = {
  kind: 'yesNo',
  id: 'yesno-colours',
  label: 'Yes or No: Colours',
  category: 'Receptive',
  description: 'See a colour and answer “Is it red?” with Yes or No.',
  config: {
    promptMode: 'AUDIO',
    errorless: 'off',
    items: [
      { say: '🟥 Is it red?', answer: 'yes' },
      { say: '🟦 Is it green?', answer: 'no' },
      { say: '🟨 Is it yellow?', answer: 'yes' },
      { say: '🟩 Is it blue?', answer: 'no' },
      { say: '🟧 Is it orange?', answer: 'yes' },
      { say: '🟪 Is it red?', answer: 'no' },
    ],
  },
};

export const yesNoTrue: ConceptDef = {
  kind: 'yesNo',
  id: 'yesno-true',
  label: 'Yes or No: Is That Right?',
  category: 'Intraverbal',
  description: 'Hear a question about the world and answer Yes or No.',
  config: {
    promptMode: 'AUDIO',
    errorless: 'off',
    items: [
      { say: '🐟 Does a fish swim?', answer: 'yes' },
      { say: '🚗 Can a car fly?', answer: 'no' },
      { say: '🧊 Is ice cold?', answer: 'yes' },
      { say: '🐄 Do cows bark?', answer: 'no' },
      { say: '☀️ Is the sun hot?', answer: 'yes' },
      { say: '🐘 Is an elephant small?', answer: 'no' },
      { say: '🛏️ Do we sleep in a bed?', answer: 'yes' },
    ],
  },
};

export const findAllCategories: ConceptDef = {
  kind: 'findAll',
  id: 'findall-categories',
  label: 'Find Them All: Categories',
  category: 'Receptive',
  description: 'Tap every picture that belongs: all the animals, all the food…',
  config: {
    boardSize: 9,
    promptMode: 'AUDIO',
    errorless: 'off',
    sequences: [
      { label: 'Tap all the animals', items: ['🐶 dog', '🐱 cat', '🐮 cow', '🐷 pig', '🐔 hen'] },
      { label: 'Tap all the food', items: ['🍎 apple', '🍞 bread', '🧀 cheese', '🍌 banana'] },
      { label: 'Tap all the vehicles', items: ['🚗 car', '🚌 bus', '🚲 bike', '🚂 train'] },
      { label: 'Tap all the clothes', items: ['👕 t-shirt', '👖 trousers', '🧦 socks', '🧢 hat'] },
    ],
  },
};

export const findAllFeatures: ConceptDef = {
  kind: 'findAll',
  id: 'findall-features',
  label: 'Find Them All: Features',
  category: 'Receptive',
  description: 'Tap every picture with a feature: things with wheels, things that fly…',
  config: {
    boardSize: 9,
    promptMode: 'AUDIO',
    errorless: 'off',
    sequences: [
      { label: 'Tap everything with wheels', items: ['🚗 car', '🚲 bike', '🚌 bus', '🛒 trolley'] },
      { label: 'Tap everything that flies', items: ['🐦 bird', '✈️ plane', '🦋 butterfly', '🚁 helicopter'] },
      { label: 'Tap everything that swims', items: ['🐟 fish', '🦆 duck', '🐬 dolphin', '🐢 turtle'] },
    ],
  },
};

export const findAllColours: ConceptDef = {
  kind: 'findAll',
  id: 'findall-colours',
  label: 'Find Them All: Colours',
  category: 'Receptive',
  description: 'Tap every red thing, every yellow thing, every green thing.',
  config: {
    boardSize: 9,
    promptMode: 'AUDIO',
    errorless: 'off',
    sequences: [
      { label: 'Tap all the red things', items: ['🍎 apple', '🍓 strawberry', '🚒 fire engine', '🌹 rose'] },
      { label: 'Tap all the yellow things', items: ['🍌 banana', '🌞 sun', '🐥 chick', '🧀 cheese'] },
      { label: 'Tap all the green things', items: ['🥦 broccoli', '🐸 frog', '🌳 tree', '🥒 cucumber'] },
    ],
  },
};
